// extracted by mini-css-extract-plugin
module.exports = {"container":"leftSidebar__container___3nn04"};